import { VisualAssetType } from './types';

export function determineMediaType(target: EventTarget) {
    // Since we know the exact elements we are rendering
    // (`video` and `img`) we can safely make an assumption
    // about the value of `localName`.
    const localName = target instanceof Element ? target.localName : undefined;

    // We do not actually use <source /> or <picture />
    // elements in <VisualAsset />. If we did, only a
    // `video > source` would throw an `error event`.
    return localName === 'video' ? VisualAssetType.Video : VisualAssetType.Image;
}

export function normalizeMashWidth(width = 0) {
    return Math.max(0, Math.floor(width));
}
